// Österreichische Stammdaten, die BEIDE Seiten brauchen.
//
// Bis 2026-09 lag diese Liste nur im Browser (`apps/web/src/lib/austria.ts`).
// Die API hatte keine Kopie — und beim Justimmo-Import muss sie den Bezirk aus
// der Postleitzahl ableiten, weil die Gegenseite ihn nicht in unserer Form
// führt. Eine zweite Liste im Worker anzulegen hiesse, dass sie eines Tages
// auseinanderlaufen; deshalb steht sie hier und der Browser holt sie von hier.

export const VIENNA_DISTRICTS = [
  '1. Innere Stadt',
  '2. Leopoldstadt',
  '3. Landstraße',
  '4. Wieden',
  '5. Margareten',
  '6. Mariahilf',
  '7. Neubau',
  '8. Josefstadt',
  '9. Alsergrund',
  '10. Favoriten',
  '11. Simmering',
  '12. Meidling',
  '13. Hietzing',
  '14. Penzing',
  '15. Rudolfsheim-Fünfhaus',
  '16. Ottakring',
  '17. Hernals',
  '18. Währing',
  '19. Döbling',
  '20. Brigittenau',
  '21. Floridsdorf',
  '22. Donaustadt',
  '23. Liesing',
] as const;

export const BUILDING_TYPES = [
  { value: 'stara_gradnja', label: 'Altbau' },
  { value: 'nova_gradnja', label: 'Neubau' },
] as const;

// Verbindliche Objektart-Liste (Zoran 2026-05-13). Free-text field on
// D1 — older records may carry legacy labels, those continue to render
// as-is; the dropdown only constrains new entries.
export const OBJECT_TYPES = [
  'Grundstücke',
  'Häuser',
  'Mietwohnhäuser',
  'Gewerbeobjekte',
  'Wohnungen',
  'Büros',
  'Geschäfte',
  'Sonderobjekte',
  'Keller',
  'Parken',
  'Gastgewerbe',
  'Beherbergung',
  'Land-/Forst.',
  'Zimmer',
] as const;

export const MARKETING_STAGE_LABELS = {
  lead: 'Lead',
  aufnahme: 'Aufnahme',
  active: 'Aktiv',
  pending: 'Pending',
  sold: 'Verkauft',
} as const;

/**
 * Den Wiener Bezirk aus der Postleitzahl ableiten — „1160" → „16. Ottakring".
 *
 * Genau so stehen die Bezirke in `properties.district` („16. Ottakring",
 * „7. Neubau"), und genau so bietet sie der Dialog an. Eine andere Schreibweise
 * wäre für einen Filter dasselbe wie gar keine.
 *
 * Wiener PLZ sind 1XX0 mit XX = 01…23. Alles andere ist kein Wiener Bezirk und
 * bekommt bewusst `null` statt einer geratenen Zuordnung: 2120 Wolkersdorf hat
 * keinen, und 1300 (Flughafen) ist keine 30. Bezirk.
 */
export function viennaDistrictFromPostalCode(zip: string | null | undefined): string | null {
  if (!zip) return null;
  const m = /^1(\d{2})0$/.exec(String(zip).trim());
  if (!m) return null;
  const n = Number(m[1]);
  if (n < 1 || n > 23) return null;
  return VIENNA_DISTRICTS[n - 1] ?? null;
}
